/* PagingTargetDeviceFeed.js */

const PagingFeed = require("../../../../../../lib/PagingFeed");
const _ = require("lodash");
const without = require("lodash/fp/without");

class PagingTargetDeviceFeed extends PagingFeed {
    _getFeed(options) {
        // get initial entity feed object
        this._entityType = _.get(options, "entityType");
        this._mongoIdOperator = _.get(options, "mongoIdOperator");
        this._idQuery = {id: {}};
        this._setIds([]);

        if (!_.isEmpty(options.filter)) {
            this._idQuery = options.filter;
        }

        return this._EntityDef.startQueryFeed(
            this._activeOrgId,
            this._entityType,
            this._idQuery,
            undefined,
            this._sort,
            {
                skip: 0,
                limit: this._pageSize * 2,
            }
        );
    }

    _feedReestablish() {
        return this._feed.reestablishFeed(
            this._activeOrgId,
            this._idQuery,
            this._entityFields,
            this._sort
        );
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadIdsForSelection(tenantId, this._entityType, selection);
    }

    _getIds() {
        return _.get(this._idQuery, `id.${this._mongoIdOperator}`);
    }
    _setIds(ids) {
        return _.set(this._idQuery, `id.${this._mongoIdOperator}`, ids);
    }

    addIds(addIds, nodeIds) {
        if (!_.isEmpty(nodeIds)) {
            this._filter = {nodeId: {$in: nodeIds}};
        }
        this._setIds(_.union(addIds, this._getIds()));
        this.reestablish();
    }

    removeIds(removeIds) {
        this._setIds(without(removeIds, this._getIds()));
        this.reestablish();
    }

    removeAllIds() {
        this._setIds([]);
        this.reestablish();
    }
}

module.exports = PagingTargetDeviceFeed;
